export default __webpack_public_path__ + "static/media/Caribbeantable_windows.c1961575.webp";